import React, { Component } from "react";
import HeaderNav from "./ecommerce/HeaderNav";
import Hero from "./ecommerce/MainHero";
import Tickets from "./ecommerce/MainTickets";
import RemainingCardsEnvelopes from "./ecommerce/RemainingCardsEnvelopes";
import LargestJackpot from "./ecommerce/MainLargestJackpot";
import HowItWorks from "./ecommerce/MainHowItWorks"
import Countdown from './ecommerce/Countdown';
import { AppContext } from "../../utils/context";
import CookieConsent from "react-cookie-consent";

const moment = require('moment-timezone');

class WebSalesTemplate extends Component {
  render() {
    const { colorPallete, settings, language, event } = this.props;

    const { config } = this.context;

    const timeZone = config.time_zone;

    // create a moment object for the event start and end time
    const startAt = moment.tz(event.start_at, timeZone);
    const endAt = moment.tz(event.end_at, timeZone);
    const startAtUTC = startAt.utc();
    const endAtUTC = endAt.utc();

    // handle sales countdown timer
    const now = moment.utc(); // UTC time
    const isBeforeSalesStart = now.isBefore(startAtUTC);
    const isAfterSalesEnd = now.isAfter(endAtUTC);

    let countdownLabel;
    if (isBeforeSalesStart) {
      countdownLabel = event.countdown_title || `${language.general_sales_start_in}:`;
    } else if (isAfterSalesEnd) {
      countdownLabel = language.general_sales_closed;
    } else {
      countdownLabel = `${language.general_sales_end_in}:`;
    }
    return (
      <div className="main font-sans" style={colorPallete}>

        {settings && language &&
          <header className="bg-primary text-accent">
            <HeaderNav
              settings={settings}
              language={language}
            />
            <div>
              <Hero event={event} language={language} settings={settings} />
              <Tickets event={event} localLanguage={language} numberModel={config.option_number_model} />
              {+settings.web_show_cards_remaining_home_page === 1 && <RemainingCardsEnvelopes event={event} settings={settings} />}
              {+settings.web_countdown_enabled === 1 && <Countdown
                date={isBeforeSalesStart ? startAtUTC : endAtUTC}
                countdownLabel={countdownLabel}
                localLanguage={language}
              />}
              {+settings.display_largest_jackpot === 1 && <LargestJackpot event={event} language={language} />}
              <HowItWorks event={event} settings={settings} language={language} />
              {+settings.cookie_consent_banner === 1 && <CookieConsent
                enableDeclineButton
                declineButtonText="Only Allow Essential Cookies"
                location="bottom"
                buttonText="Accept"
                cookieName="ecomConsent" // Not really needed, but changed it to prevent possible future issues if default is used
                style={{ background: settings.cookie_banner_background_color }}
                buttonStyle={{background: settings.cookie_banner_button_accept_color, color: settings.cookie_banner_text_color, fontSize: "13px"}}
                declineButtonStyle={{ background: settings.cookie_banner_button_decline_color, color: settings.cookie_banner_text_color, fontSize: "13px" }} // 4e503b
                expires={150}
                visible="show"
              >
              <span style={{color: settings.cookie_banner_text_color}}>{language.cookie_consent_banner_text}</span>
            </CookieConsent>}
            </div>
          </header>
        }
      </ div>
    );
  }
}
WebSalesTemplate.contextType = AppContext;

export default WebSalesTemplate;
